module.exports = __webpack_public_path__ + "static/media/vehicle.ebe3f2de.png";